const timezoneCodesToNames = {
    ET: 'America/New_York', // Eastern Time
    CT: 'America/Chicago', // Central Time
    MT: 'America/Denver', // Mountain Time
    MT: 'America/Phoenix', // Mountain Time (Arizona)
    PT: 'America/Los_Angeles' // Pacific Time
};

// The Sports Data API returns a hodgepodge of timezone names; map them to our two-letter abbrevs:
const apiTimezoneIdsToLetterCodes = {
    // Eastern:
    'US/Eastern': 'ET',
    'America/New_York': 'ET',
    'America/Montreal': 'ET',
    'America/Toronto': 'ET',
    'America/Detroit': 'ET',
    'America/Kentucky/Louisville': 'ET',

    // Central:
    'US/Central': 'CT',
    'America/Chicago': 'CT',
    'America/Winnipeg': 'CT',

    // Mountain:
    'US/Mountain': 'MT',
    'America/Denver': 'MT',
    'America/Edmonton': 'MT',

    // Mountain (Arizona):
    'America/Phoenix': 'MST',

    // Pacific:
    'US/Pacific': 'PT',
    'America/Vancouver': 'PT',
    'America/Los_Angeles': 'PT'
};

export {
    timezoneCodesToNames,
    apiTimezoneIdsToLetterCodes
};
